document.addEventListener('DOMContentLoaded', function() {
  const searchIcon = document.querySelector('.site-header__search-icon');
  const searchForm = document.querySelector('#mobile_search form');

  if (searchIcon && searchForm) {
    searchIcon.addEventListener('click', function(e) {
      e.preventDefault();
      if (searchForm.style.display === 'none' || !searchForm.style.display) {
        searchForm.style.display = 'block';
      } else {
        searchForm.style.display = 'none';
      }
    });
  }
});



document.addEventListener('DOMContentLoaded', function () {

  function applyZoomToActiveImage() {
    // Reset zoom and remove old listeners from all zoomable images
    var zoomImgs = document.querySelectorAll('.proFeaturedImage .slick-slide img');
    zoomImgs.forEach(function(img) {
      img.style.transform = 'scale(1)';
      img.style.transformOrigin = 'center center';
      img.removeEventListener('mousemove', handleMouseMove);
      img.removeEventListener('mouseleave', handleMouseLeave);
    });

    // Get the currently active image
    var currentImg = document.querySelector('.proFeaturedImage .slick-current img');
    if (!currentImg) return;

    var scale = 2; // Zoom level

    function handleMouseMove(e) {
      var rect = currentImg.getBoundingClientRect();
      var x = e.clientX - rect.left;
      var y = e.clientY - rect.top;
      var xPercent = (x / rect.width) * 100;
      var yPercent = (y / rect.height) * 100;

      currentImg.style.transformOrigin = `${xPercent}% ${yPercent}%`;
      currentImg.style.transform = `scale(${scale})`;
    }

    function handleMouseLeave() {
      currentImg.style.transform = 'scale(1)';
    }

    // Add zoom listeners to current image
    currentImg.addEventListener('mousemove', handleMouseMove);
    currentImg.addEventListener('mouseleave', handleMouseLeave);
  }

  // Initial run
  applyZoomToActiveImage();

  // Re-apply zoom effect on Slick slide change (requires jQuery for Slick events)
  if (typeof jQuery !== 'undefined') {
    jQuery('.proFeaturedImage').on('afterChange', function () {
      applyZoomToActiveImage();
    });
  }

});



 
